// installed dependecies
import React, { useEffect, useState, useRef } from 'react';
import { observer } from 'mobx-react-lite';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
// stores

import useStores from '../../hooks/use-store';
//
import { useFocusElement, useLanguage } from '../../hooks';
import {
  Container,
  HeadingContainer,
  LogoContainer,
  Title,
  FormWrapper,
  LoginForm,
  BlockFormField,
  LoginLabel,
  // LoginButton,
  Error,
  Helptext,
  ForgotLogin,
} from './Styles';
// import logo from '../../assets/images/logo-inverse.png'
import { Icon, Select } from './../../components';
import { isEnterKey } from '../../shared/utils/common';
import { Button } from 'semantic-ui-react';
import { providers } from './../../data/';
import { version } from './../../../package.json';
import Version from './../../components/Version';
import { getSessionToken } from './../../stores/utils';

const Login = (props) => {
  const {
    DashboardStore: { connected, setProperty },
    APIWebSocketStore: { apiConnect },
    AuthStore: { errorMessage, setProperty: setAuthProperty },
    ProviderStore: { language },
    UIStore: { handleLogin, handleLogout },
  } = useStores();

  const {
    value: providerId,
    text: providerName,
    logo: providerLogo,
  } = providers[0];

  const [isLoggingIn, setIsLoggingIn] = useState(false);

  const {
    invalidUserPwdText,
    headerText,
    loginButtonText,
    userNameLabel,
    passwordLabel,
    switchAuctionButtonText,
    logoutButtonText,
    helpLabelText,
    providerSelectText,
  } = useLanguage();

  const history = useHistory();
  const loginButtonRef = useRef();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [userNameRef] = useFocusElement(username === '');
  const [providerValue, setProviderValue] = useState(providerId);
  const sessionToken = getSessionToken();

  const clearErrorMessage = () => {
    setAuthProperty('errorMessage', '');
    setIsLoggingIn(false);
  };

  const handlePasswordOnKeyPress = (e) => {
    if (isEnterKey(e)) {
      setIsLoggingIn(true);
      handleLogin(username, password, providerValue);
    }
  };

  const onProviderSelectionChange = (e) => {
    setProviderValue(e.target.value);
  };

  const logo = require(`../../assets/images/${providerLogo}`);
  const fullPathToLogo = `${process.env.PUBLIC_URL}${logo}`;

  useEffect(() => {
    const versionNode = document.getElementsByClassName('version')[0];

    if (versionNode) {
      versionNode.innerHTML = `v${version}`;
      versionNode.style.color = '#000';
      versionNode.style.position = 'absolute';
      versionNode.style.top = '0';
      versionNode.style.right = '10';
      versionNode.style.marginTop = '10px';
      versionNode.style.textAlign = 'right';
      versionNode.style.marginLeft = '-10px';
    }
  }, []);

  useEffect(() => {
    let timer;
    if (connected && sessionToken) {
      timer = setTimeout(() => {
        window.location.href = '/dashboard';
      }, 1500);
    }
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <Version />
      <Container>
        <HeadingContainer>
          <LogoContainer>
            <img src={fullPathToLogo} alt={providerName} />
          </LogoContainer>
          <Title>{headerText}</Title>
        </HeadingContainer>
        <FormWrapper>
          <LoginForm>
            {!connected ? (
              <>
                {/* <BlockFormField> */}
                {/* <Helptext><Icon icon='question-circle' size='small' />{helpLabelText}</Helptext> */}
                {/* </BlockFormField> */}
                <BlockFormField>
                  <LoginLabel>{userNameLabel}</LoginLabel>
                  <input
                    data-testid="username"
                    ref={userNameRef}
                    type="text"
                    autoComplete="off"
                    tabIndex={1}
                    value={username}
                    onChange={(event) => {
                      clearErrorMessage();
                      setUsername(event.target.value);
                    }}
                  />
                </BlockFormField>
                <BlockFormField>
                  <LoginLabel>{passwordLabel}</LoginLabel>
                  <input
                    data-testid="password"
                    type="password"
                    autoComplete="off"
                    tabIndex={2}
                    value={password}
                    onKeyPress={handlePasswordOnKeyPress}
                    onChange={(event) => {
                      clearErrorMessage();
                      setPassword(event.target.value);
                    }}
                  />
                </BlockFormField>
                <BlockFormField style={{ display: 'none' }}>
                  {/* <LoginLabel>{providerLabelText}</LoginLabel> */}
                  <Select
                    valueProp="value"
                    textProp="text"
                    value={providerValue}
                    currentValue={providerValue}
                    data={providers}
                    // noneSelectedText={providerSelectText}
                    onChange={onProviderSelectionChange}
                  />
                </BlockFormField>
                <BlockFormField>
                  <LoginButton2
                    // primary
                    data-testid="login"
                    ref={loginButtonRef}
                    onClick={(e) => {
                      e.preventDefault();
                      setIsLoggingIn(true);
                      handleLogin(username, password, providerValue);
                    }}
                    size="large"
                    tabIndex={3}
                    content={loginButtonText}
                    icon={isLoggingIn ? null : 'lock'}
                    loading={!errorMessage && isLoggingIn}
                    // color={foreColor}
                  />
                  {/* <LoginButton
                                    data-testid="login"
                                    ref={loginButtonRef}
                                    tabIndex={3}
                                    type="button"
                                    onClick={() => handleLogin(username, password, providerValue)}
                                >
                                    <Icon icon="user" />
                                    {loginButtonText}
                                </LoginButton> */}
                </BlockFormField>
                {/* <ForgotLogin><Icon icon='lock' size='small' /> Forgot username or password?</ForgotLogin> */}
              </>
            ) : (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  fontSize: '22px',
                  fontWeight: 'bold',
                  width: '100%',
                  height: '100%',
                  textAlign: 'center',
                  lineHeight: '32px',
                }}
              >
                Looks like you're connected, one moment as we try to redirect
                you to the dashboard...
              </div>
            )}
            {errorMessage && loginButtonRef.current && (
              <Error data-testid="error">{errorMessage}</Error>
            )}
          </LoginForm>
        </FormWrapper>
      </Container>
    </>
  );
};
export default observer(Login);

export const LoginButton2 = styled(Button)`
  background-color: #a62b2b !important;
  color: #fff !important;
  & i {
    color: #fff !important;
  }
`;
